module.exports = __webpack_public_path__ + "img/input_11.dae1bae1.png";